export default "__VITE_ASSET__e89787f0__"